import React from "react"
import PropTypes from "prop-types"
import _map from "lodash/map"

export default class PerformanceTriggerActionChart extends React.Component {
  async componentDidMount() {
    const Highcharts = await import("highcharts")
    Highcharts.setOptions(window.globalHighchartsOptions)

    this.chart = new Highcharts.Chart({
      chart: {
        renderTo: this.chartContainer,
        type: "bar",
        height: this.props.height,
      },
      colors: _map(this.props.categories, category => {
        return category.color
      }),
      title: {
        text: "",
      },
      legend: {
        align: "right",
        verticalAlign: "top",
        margin: 30,
        padding: 0,
        itemStyle: {
          color: "#333",
          fontSize: "14",
          fontWeight: "700",
        },
      },
      tooltip: {
        animation: false,
        backgroundColor: "#333",
        borderWidth: 0,
        borderRadius: 10,
        headerFormat: null,
        padding: 10,
        pointFormat: "{series.name}: <b>{point.y}</b><br>",
        valueSuffix: " ms",
        shadow: false,
        shared: true,
        style: {
          color: "#fff",
          fontSize: 14,
        },
      },
      xAxis: {
        categories: _map(this.props.speeds, item => {
          return item.name
        }),
        labels: {
          style: {
            color: "#999",
            fontSize: "14",
            fontWeight: "700",
          },
        },
        tickmarkPlacement: "on",
        gridLineWidth: 4,
        gridLineColor: "#f5f5f5",
        lineWidth: 0,
        tickInterval: 1,
        tickWidth: 0,
      },
      yAxis: {
        min: 0,
        title: {
          style: {
            color: "#999",
            fontSize: "16",
            fontWeight: "700",
          },
          text: "90th-percentile time in milliseconds",
        },
        labels: {
          step: 2,
          style: {
            color: "#999",
            fontSize: "14",
            fontWeight: "700",
          },
        },
        gridLineWidth: 0,
        showLastLabel: false,
      },
      plotOptions: {
        bar: {
          groupPadding: 0,
          pointPadding: 0,
          shadow: false,
          minPointLength: 5,
          stacking: "normal",
        },
        series: {
          animation: false,
          states: {
            hover: {
              enabled: false,
            },
          },
        },
      },
      series: _map(this.props.categories, category => {
        return {
          name: category.label,
          pointWidth: 12,
          data: _map(this.props.speeds, item => {
            return (parseInt(item[category.key] / 10, 10) + 1) * 10 // round to the nearest 10
          }),
        }
      }),
      credits: {
        enabled: false,
      },
    })
  }

  componentWillUnmount() {
    this.chart.destroy()
  }

  render() {
    return (
      <div className="chart-container" ref={c => (this.chartContainer = c)} />
    )
  }
}

PerformanceTriggerActionChart.propTypes = {
  categories: PropTypes.array.isRequired,
  speeds: PropTypes.array.isRequired,
  height: PropTypes.number,
}
